<template>
  <!-- @submit pošlje podatke na server .prevent pa to prepreči ker še nimamo backenda -->
  <!-- podatki bodo tako vidni samo lokalno  -->
  <form @submit.prevent="submitForm">
    <!-- for v label kaže da na input na katerega se navezuje -->
    <div class="form-control" :class="{ invalid: !firstName.isValid }">
      <label for="firstname">First Name</label>
      <!-- .val za validacijo vsakega posameznega obrazca -->
      <!-- clearValidity je klicana vsakič ko izgubi fokus oz. kliknemo iz obrazca-> @blur -->
      <input
        type="text"
        id="firstname"
        v-model.trim="firstName.val"
        @blur="clearValidity('firstName')"
      />
      <p v-if="!firstName.isValid">First name must not be empty</p>
    </div>

    <div class="form-control" :class="{ invalid: !lastName.isValid }">
      <label for="lastname">Last Name</label>
      <input
        type="text"
        id="lastname"
        v-model.trim="lastName.val"
        @blur="clearValidity('lastName')"
      />
      <p v-if="!lastName.isValid">Last name must not be empty</p>
    </div>

    <div class="form-control" :class="{ invalid: !description.isValid }">
      <label for="description">Description</label>
      <textarea
        id="description"
        rows="5"
        v-model.trim="description.val"
        @blur="clearValidity('description')"
      ></textarea>
      <p v-if="!description.isValid">Description must not be empty</p>
      <!-- .trim da odstraniš nepotreben prostor na koncu in začetku texta -->
    </div>

    <div class="form-control" :class="{ invalid: !rate.isValid }">
      <label for="rate">Hourly Rate</label>
      <input
        type="number"
        id="rate"
        v-model.number="rate.val"
        @blur="clearValidity('rate')"
      />
      <p v-if="!rate.isValid">Rate must be assigned</p>
      <!-- .number je konverzija v številko -->
    </div>

    <div class="form-control" :class="{ invalid: !areas.isValid }">
      <h3>Areas of Expertise</h3>
      <div>
        <!-- value je pomemben da dobiš podatke iz checkboxa -->
        <input
          type="checkbox"
          id="frontend"
          value="frontend"
          v-model="areas.val"
          @blur="clearValidity('areas')"
        />
        <label for="frontend">Frontend Development</label>
      </div>

      <div>
        <input
          type="checkbox"
          id="backend"
          value="backend"
          v-model="areas.val"
          @blur="clearValidity('areas')"
        />
        <label for="backend">Backend Development</label>
      </div>

      <div>
        <input
          type="checkbox"
          id="career"
          value="career"
          v-model="areas.val"
          @blur="clearValidity('areas')"
        />
        <label for="career">Career Advisory</label>
      </div>
      <p v-if="!areas.isValid">Please chose one</p>
    </div>
    <p v-if="!formIsValid">Please fix the above errors and submit again</p>
    <base-button>Register</base-button>
  </form>
</template>

<script>
export default {
  emits: ['save-data'],
  data() {
    return {
      // val & isValid se uporablja za validacijo obrazca.
      firstName: {
        val: '',
        isValid: true,
      },
      lastName: {
        val: '',
        isValid: true,
      },
      description: {
        val: '',
        isValid: true,
      },
      rate: {
        val: null,
        isValid: true,
      },
      areas: {
        val: [],
        isValid: true,
      },

      formIsValid: true,
    };
  },
  methods: {
    // da je kvadratek spet normalen ko vneseš ustrezno vrednost
    clearValidity(input) {
      // input je eden izmed objektov v data(), če je ta ustrezen isValid value = true
      this[input].isValid = true;
    },
    validateForm() {
      this.formIsValid = true; //najprej je true
      if (this.firstName.val === '') {
        // če je empty string
        this.firstName.isValid = false; // je invalid
        this.formIsValid = false; // celoten obrazec je invalid
      }
      if (this.lastName.val === '') {
        this.lastName.isValid = false;
        this.formIsValid = false;
      }
      if (this.description.val === '') {
        this.description.isValid = false;
        this.formIsValid = false;
      }
      if (this.description.val === '') {
        this.description.isValid = false;
        this.formIsValid = false;
      }
      if (!this.rate.val || this.rate.val < 0) {
        // če ni vnešen rate ali je manjši od 0
        this.rate.isValid = false; // je invalid
        this.formIsValid = false;
      }
      if (this.areas.val.length === 0) {
        // če array nima niti en value
        this.areas.isValid = false;
        this.formIsValid = false;
      }
    },
    // funkcija ki nosi nove vrednosti dodane preko v-model v data() shranjene const formData objekt
    submitForm() {
      this.validateForm();
      if (!this.formIsValid) {
        // če je form invalid
        return;
      } // se submitForm() naprej od tukaj ne izvede (torej submit form ne dela ne pošlje podatkov)

      const formData = {
        first: this.firstName.val,
        last: this.lastName.val,
        desc: this.description.val,
        rate: this.rate.val,
        areas: this.areas.val,
      };
      //   console.log(formData);

      // emitamo 'save-data' ki nosi podatke formData
      this.$emit('save-data', formData);
    },
  },
};
</script>

<style scoped>
.form-control {
  margin: 0.5rem 0;
}

label {
  font-weight: bold;
  display: block;
  margin-bottom: 0.5rem;
}

input[type='checkbox'] + label {
  font-weight: normal;
  display: inline;
  margin: 0 0 0 0.5rem;
}

input,
textarea {
  display: block;
  width: 100%;
  border: 1px solid #ccc;
  font: inherit;
}

input:focus,
textarea:focus {
  background-color: #f0e6fd;
  outline: none;
  border-color: #3d008d;
}

input[type='checkbox'] {
  display: inline;
  width: auto;
  border: none;
}

input[type='checkbox']:focus {
  outline: #3d008d solid 1px;
}

h3 {
  margin: 0.5rem 0;
  font-size: 1rem;
}

.invalid label {
  color: red;
}

.invalid input,
.invalid textarea {
  border: 1px solid red;
}
</style>
